import lodash from "lodash";
function clean(el) {
  function internalClean(el) {
    return lodash.transform(el, function (result, value, key) {
      const isCollection = lodash.isObject(value);
      const isNumber = lodash.isNumber(value);
      const cleaned = isCollection ? internalClean(value) : value;

      if (!isNumber) {
        if (lodash.isEmpty(cleaned)) return;
      }

      lodash.isArray(result) ? result.push(cleaned) : (result[key] = cleaned);
    });
  }

  return lodash.isObject(el) ? internalClean(el) : el;
}

export default clean;
